export default "__VITE_ASSET__CTALEIPG__"